import { CandidateType, GlobalStatus, SourceType } from '@gtpl/shared-models/common-models';
import {Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from 'typeorm';

@Entity('profiles')
export class Profiles{
   
    @PrimaryGeneratedColumn('increment', {name: 'profile_id'})
    profileId: number;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'candidate_name'
    })
    candidateName: string;

    @Column('varchar',{
    
        name: 'job_description'
    })
    jobDescription: string;

    @Column({
        nullable: false,
        name: 'profile_date'
    })
    profileDate: Date;

    @Column('varchar',{
        nullable: false,
        length: 15,
        name: 'mobile_number'
    })
    mobileNumber: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'qualification'
    })
    qualification: string;

    @Column('varchar', {
        nullable: false,
        length: 60,
        name: 'technologies'
    })
    skills: string;

    // @Column('varchar', {
    //     nullable: false,
    //     length: 20,
    //     name: 'stack'
    // })
    // stack: string;

    @Column('varchar',{
        nullable: true,
        length: 15,
        name: 'alt_mobile_number'
    })
    altMobileNumber: string;

    @Column('int',{
        nullable:true,
        name: 'expected_ctc'
    })
    expectedCTC: number;

    @Column({
        type: 'enum',
        enum: CandidateType,
        nullable: true,
        name: 'candidate_type',
        default: CandidateType.Fresher
    })
    candidateType: CandidateType;

    @Column('int',{
        nullable: true,
        name: 'current_ctc'
    })
    currentCTC: number;

    @Column('int',{
        nullable: true,
        name: 'notice_period'
    })
    noticePeriod: number;

    @Column('int',{
        nullable: true,
        name: 'experience'
    })
    experience: number;

    @Column({
        type: 'enum',
        enum: SourceType,
        nullable: true,
        name: 'source_type',
        default: SourceType.Consultancy
    })
    sourceType: SourceType;

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'referred_by'
    })
    referredBy: string;

    @Column('varchar',{
        nullable: true,
        length: 60,
        name: 'remarks'
    })
    remarks: string;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user'
    })
    createdUser: string | null;
    
    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

}